<script>
import utilsMixin from "@mixins/utilsMixin";
import AkDialog from "@components/general/AkDialog.vue";

export default {
  name: "AkActualite",
  components: {AkDialog},
  mixins: [utilsMixin],
  props: {
    actualite: {
      type: Object,
      required: true
    }
  },
  methods: {
    openDetails($event) {
      // Si c'est une balise <a> on ne fait rien pour éviter de bloquer le lien
      if ($event.target.tagName === 'A') {
        return;
      }

      this.$refs.dialog.show();
    },
  }
}
</script>

<template>
  <div class="card card-statistics actualite-card">
    <div class="card-header">
      <div class="card-heading">
        <div class="row align-items-center">
          <div class="col-lg-6 col-8">
            <h5 class="card-title">{{ actualite.title }}</h5>
          </div>
          <div class="col-lg-6 col-4 text-right">
            Publié le {{ displayDate(actualite.dateStart) }} par {{ actualite.creatorName }}
          </div>
        </div>
      </div>
    </div>
    <div @click="openDetails" class="tinymce-result tinymce-result-size wysiwyg card-body vld-parent pointer">
      <div v-html="actualite.content"></div>
    </div>
  </div>
  <AkDialog :title="actualite.title" ref="dialog" :show="false" width="350" :no-validate-label="true" :cancel-label="$t('close')">
    <div class="tinymce-result wysiwyg vld-parent">
      <div v-html="actualite.content"></div>
    </div>
  </AkDialog>
</template>

<style scoped>
</style>